import { SelectC } from 'components'
import { useState } from 'react'
import { useLoadOrdersCustomers } from 'modules/orders/hooks'
import { useDebounce } from 'utils'
import { useFormContext } from 'react-hook-form'

type Props = {
  loading: boolean
}

export const PaymentResponsible = ({ loading }: Props) => {
  const [search, setSearch] = useState<string>('')
  const searchDebounced = useDebounce(search, 250)

  const { watch } = useFormContext()
  // const { data, isLoading } = useLoadOrderSalesChannels({
  //   page: 1,
  //   limit: 100,
  //   search: searchDebounced,
  //   filters: {}
  // })

  const { data, isLoading } = useLoadOrdersCustomers({
    page: 1,
    limit: 100,
    search: searchDebounced,
    sellerId: watch('seller')?.id
  })

  const handleChange = (value: string, reason: string) => {
    if (reason === 'input' || reason === 'clear') setSearch(value)
  }

  return (
    <SelectC
      name="paymentResponsible"
      label="Responsável pelo pagamento"
      options={data?.data}
      onInputChange={(e, value, reason) => handleChange(value, reason)}
      getOptionLabel={(option: any) => option?.id + ' - ' + option?.name}
      loading={isLoading || loading}
    />
  )
}
